import type { PurchaseOrder } from '@ztechapps/common.contract'
import { PurchaseOrderStatusEnum } from '@ztechapps/common.contract'
import { usePurchaseOrderDocumentLock } from '@ztechapps/purchase-order.common'
import { useCanEditPurchaseOrder } from '../../../../hooks/useCanEditPurchaseOrder'

export const usePurchaseOrderStatusEditable = ({
  purchaseOrderId,
  purchaseOrder,
  isLocked,
}: {
  purchaseOrderId: string
  purchaseOrder?: PurchaseOrder
  isLocked?: boolean
}): boolean => {
  const hasCanEditOrderRole = useCanEditPurchaseOrder()
  // The lock hook stays unconditional (rules-of-hooks); a caller that already holds the lock
  // result passes it in and the internal subscription's value goes unused.
  const documentLockResult = usePurchaseOrderDocumentLock({ value: purchaseOrderId })
  const locked = isLocked ?? documentLockResult?.isLocked

  return (
    hasCanEditOrderRole &&
    !locked &&
    purchaseOrder?.status !== PurchaseOrderStatusEnum.PartiallyReceived &&
    purchaseOrder?.status !== PurchaseOrderStatusEnum.Received &&
    purchaseOrder?.status !== PurchaseOrderStatusEnum.Cancelled
  )
}
